import {
    addUser,
    changeCreateUserStatus,
    changeUserStatus,
    editUser, getBotAccessUse,
    getUser,
    updateProfilePhoto,
} from "./users.actions";
import {
    addIntegrationDriveService,
    addUserService,
    editUserService, getBotAccessUserService,
    getUserService,
    getUserWithEmailService, updateIndexDriveService,
    updateProfilePhotoService,
} from "../../services/user.service";
import {deleteGoogleDriveAccountService, deleteOneDriveAccountService} from "../../services/drive-hr.service";
import {toastr} from "react-redux-toastr";

export const getUserThunk = (id) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            const data = await getUserService(id);
            console.log("data get user", data);
            if (!data.error) {
                dispatch(getUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

/** get user with email **/
export const getUserWithEmailThunk = (email) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        console.log("LOADING USER");
        try {
            const data = await getUserWithEmailService(email);
            console.log("data get user EMAIL", data);
            if (!data.error) {
                dispatch(getUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};


export const addUserThunk = (obj) => {
    return async (dispatch) => {
        dispatch(changeCreateUserStatus('loading'));
        try {
            await addUserService(obj);
            const data = await getUserWithEmailService(obj.email);
            console.log("data", data);
            if (!data.error){
                dispatch(addUser(data));
                dispatch(changeCreateUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const editUserThunk = (obj, id) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            await editUserService(obj, id);
            // const data = await getUserService(id);
            const data = await getUserWithEmailService(obj.email);
            console.log("data edit", data);
            if (!data.error) {
                dispatch(editUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const updateDriveUserThunk = (obj, id) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            const user = await addIntegrationDriveService(obj, id);
            const data = await getUserWithEmailService(user.email);
            if (!data.error) {
                dispatch(editUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const deleteDriveUserThunk = (token, masterEmail, tenantId, uniqueId) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            const data = await deleteOneDriveAccountService(token, masterEmail, tenantId,uniqueId);
            if (!data.error) {
                toastr.success(`Microsoft Onedrive account deleted successfully`);
                dispatch(editUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const deleteGoogleDriveUserThunk = (token, masterEmail) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            const data = await deleteGoogleDriveAccountService(token, masterEmail);
            if (!data.error) {
                toastr.success(`Google drive account deleted successfully`);
                dispatch(editUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const updateIndexUserThunk = (obj, id) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            const user = await updateIndexDriveService(obj, id);
            const data = await getUserWithEmailService(user.email);
            if (!data.error) {
                dispatch(editUser(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

export const updateProfilePhotoThunk = (obj, id) => {
    return async (dispatch) => {
        dispatch(changeUserStatus('loading'));
        try {
            console.log("LOADING update");
            await updateProfilePhotoService(obj, id);
            const data = await getUserService(id);
            console.log("data update profile photo", data);
            if (!data.error) {
                dispatch(updateProfilePhoto(data));
                dispatch(changeUserStatus('loaded'));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};

/** GET bot acccess permissions for users*/
export const getBotAccessUserThunk = (email) => {
    return async (dispatch) => {
        // dispatch(changeUserStatus('loading'));
        // console.log("LOADING USER");
        try {
            const data = await getBotAccessUserService({email});
            console.log("data get access user", data);
            if (!data.error) {
                dispatch(getBotAccessUse(data));
            }
        } catch (error) {
            console.error(error);
            toastr.error(`Something went wrong, please reload the page to try again`);
        }
    };
};
